import { capitalize as _capitalize, startCase } from 'lodash-es'

export function capitalize(input) {
  return _capitalize(input)
}

export function capitalizeWords(input) {
  return startCase(input?.toLowerCase() || '')
}

export function lowercase(input) {
  return input?.toLowerCase() || ''
}

export function rmUnderscores(input) {
  return input?.split('_')?.join(' ') || ''
}
